import { useEffect, useState } from 'react'
import styles from '../styles/chatbot.module.scss'
import * as ReactDOM from 'react-dom'

import Stars from '../../../assets/stars-2x.png'

interface HighlightExplainProps {
  onExplain: (text: string) => void
}

const HighlightExplain = ({ onExplain }: HighlightExplainProps) => {
  const [showButton, setShowButton] = useState(false)
  const [buttonPosition, setButtonPosition] = useState({ top: 0, left: 0 })
  const [selectedText, setSelectedText] = useState('')

  const handleMouseUp = () => {
    const selection = window.getSelection()
    if (
      selection &&
      selection.rangeCount > 0 &&
      selection.toString().trim() !== ''
    ) {
      const range = selection.getRangeAt(0)
      const rect = range.getBoundingClientRect()

      setSelectedText(selection.toString())
      setButtonPosition({
        top: rect.top + window.scrollY - 5,
        left: rect.left + window.scrollX + rect.width + 12
      })
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mouseup', handleMouseUp)
    return () => {
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])

  const button = showButton ? (
    <button
      className={styles['explain-button']}
      style={{
        position: 'absolute',
        top: `${buttonPosition.top}px`,
        left: `${buttonPosition.left}px`
      }}
      onClick={() => onExplain(selectedText)}
      data-testid='explainButton'
    >
      Explain with{' '}
      <img src={Stars} alt='Stars' className={styles['explain-stars']} />
      SensAI
      <div className={styles['tooltip-arrow']}></div>
    </button>
  ) : null

  return ReactDOM.createPortal(button, document.body)
}

export default HighlightExplain
